import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=475e8cd8&scoped=true&"
import script from "./wangeditor.vue?vue&type=script&lang=js&"
export * from "./wangeditor.vue?vue&type=script&lang=js&"
import style0 from "./wangeditor.vue?vue&type=style&index=0&id=475e8cd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e8cd8",
  null
  
)

export default component.exports